import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "img", "placeholder"]

  preview() {
    const file = this.inputTarget.files[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = (e) => {
      if (this.hasImgTarget) {
        this.imgTarget.src = e.target.result
      } else if (this.hasPlaceholderTarget) {
        const img = document.createElement("img")
        img.src = e.target.result
        img.className = "avatar-upload__img"
        img.dataset.avatarPreviewTarget = "img"
        this.placeholderTarget.replaceWith(img)
      }
    }
    reader.readAsDataURL(file)
  }
}
